import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { A as ArrowDown } from './icon.js';

const gDropDownCss = ".g__dropdown__label__text--hidden{position:absolute;overflow:hidden;clip:rect(0 0 0 0);height:1px;width:1px;margin:-1px;padding:0;border:0}.g__dropdown{font-family:\"Superscripts-Roboto\", \"Roboto\", \"Noto Sans TC\", \"Noto Sans SC\", \"Noto Sans JP\", \"Noto Sans KR\", \"Prompt\", sans-serif}.g__dropdown{box-sizing:border-box;display:flex;flex-direction:column;width:100%}.g__dropdown__label{display:block}.g__dropdown__label__text{font-weight:700;font-size:0.9em;text-align:left}.g__dropdown__required{color:#920000;padding-left:0.25rem}.g__dropdown select{border-radius:0;font-size:1em;color:#000;outline:0;width:100%;height:auto;background-color:#fff;-webkit-appearance:none;appearance:none;border:1px solid #d9d9d9;margin:0.3rem 0 0.3rem 0;padding:0.875em 3em 0.875em 0.875em}.g__dropdown select::-ms-expand{display:none}.g__dropdown select:disabled{cursor:not-allowed;opacity:0.5}.g__dropdown select:disabled+.g__dropdown__arrow{opacity:0.5}.g__dropdown select:not(:disabled):focus,.g__dropdown select:not(:disabled):active{border-color:#000;outline:none}.g__dropdown__wrapper{position:relative;display:flex;align-items:center}.g__dropdown__arrow{position:absolute;right:1rem;pointer-events:none}.g__dropdown__arrow svg{width:0.75rem;height:0.75rem;display:block}.g__dropdown--error select{border-color:#920000}";
const GDropDownStyle0 = gDropDownCss;

const GDropDown$1 = /*@__PURE__*/ proxyCustomElement(class GDropDown extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.label = undefined;
        this.hideLabel = false;
        this.required = false;
        this.error = false;
        this.dataTestId = undefined;
    }
    componentWillRender() {
        if (!this.label) {
            /* eslint-disable */
            console.error('No label attribute set on g-drop-down component');
        }
    }
    render() {
        var _a, _b, _c, _d, _e;
        const baseClass = 'g__dropdown';
        const componentClasses = {
            [baseClass]: true,
            [`${baseClass}--error`]: Boolean(this.error),
        };
        const labelTextClasses = {
            g__dropdown__label__text: true,
            'g__dropdown__label__text--hidden': Boolean(this.hideLabel),
        };
        /* eslint-disable no-return-assign */
        return (h(Host, { key: '756122b0cbee857c65ff95d5797c2daaf4c3fba0', class: componentClasses, "data-testid": ((_a = this.dataTestId) === null || _a === void 0 ? void 0 : _a.host) || baseClass }, h("label", { key: '7592586b8d9b71f3e4b93de562017dc79eaf7fd2', class: "g__dropdown__label" }, h("span", { key: 'e635a14002c15b8848de46fb60bb4c88501c97ae', class: labelTextClasses, "data-testid": (_b = this.dataTestId) === null || _b === void 0 ? void 0 : _b.labelText }, this.label, this.required && (h("span", { key: '876bfafd7b9b863e386313cda4ab1735ce6fa95c', class: "g__dropdown__required", "data-testid": (_c = this.dataTestId) === null || _c === void 0 ? void 0 : _c.dropdownAsterisk }, "*"))), h("span", { key: '86b5accdedd6259cb1be3d9440a2f1976d013001', class: "g__dropdown__wrapper", "data-testid": (_d = this.dataTestId) === null || _d === void 0 ? void 0 : _d.dropdownWrapper }, h("slot", { key: '0bafb8731eeb410c6f38603d0773e7592875f4f3' }), h("span", { key: 'dcd8ca82f35b9e386e53ec02ce32f26d987bfa7d', class: "g__dropdown__arrow", "data-testid": (_e = this.dataTestId) === null || _e === void 0 ? void 0 : _e.dropdownArrow, "aria-hidden": "true", innerHTML: ArrowDown })))));
    }
    static get style() { return GDropDownStyle0; }
}, [4, "g-drop-down", {
        "label": [1],
        "hideLabel": [4, "hide-label"],
        "required": [4],
        "error": [4],
        "dataTestId": [16]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["g-drop-down"];
    components.forEach(tagName => { switch (tagName) {
        case "g-drop-down":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, GDropDown$1);
            }
            break;
    } });
}

const GDropDown = GDropDown$1;
const defineCustomElement = defineCustomElement$1;

export { GDropDown, defineCustomElement };

//# sourceMappingURL=g-drop-down.js.map